module.exports = __webpack_public_path__ + "img/home-gray.cc350e28.png";